// extracted by mini-css-extract-plugin
module.exports = {"description":"qtmVB4V6Ks3NJnQE5boxi"};